import React from "react";
import { useFormContext, Controller } from "react-hook-form";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

export default function TextareaField({
  name,
  label,
  required,
  inputId,
  placeholder,
  rules,
  value,
  onChange,
  error,
  className = "",
  ...props
}) {
  const formContext = useFormContext();

  // If no form context OR no name → render normal textarea
  if (!formContext || !name) {
    return (
      <div className="w-full">
        {/* Label */}
        {label && (
          <Label
            htmlFor={inputId}
            className="block mb-1 text-sm font-medium text-secondary capitalize"
          >
            {label}
            {required && <span className="text-red-500">*</span>}
          </Label>
        )}

        {/* Plain Textarea */}
        <Textarea
          id={inputId}
          placeholder={placeholder}
          value={value ?? ""}
          onChange={onChange}
          className={`!rounded-[1rem] !h-[6rem] ${
            error ? "border-destructive" : ""
          } ${className}`}
          {...props}
        />

        {/* Error */}
        {error && (
          <p className="text-red-500 text-xs mt-1">
            {typeof error === "string" ? error : error.message}
          </p>
        )}
      </div>
    );
  }

  // With react-hook-form
  const { control } = formContext;

  return (
    <div className="w-full">
      {/* Label */}
      {label && (
        <Label
          htmlFor={inputId}
          className="block mb-1 text-sm font-medium text-secondary capitalize"
        >
          {label}
          {required && <span className="text-red-500">*</span>}
        </Label>
      )}

      {/* Controller */}
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field, fieldState: { error } }) => (
          <>
            <Textarea
              {...field}
              id={inputId}
              placeholder={placeholder}
              value={field.value ?? ""}
              aria-invalid={!!error}
              className={`!rounded-[1rem] !h-[6rem] ${
                error ? "border-destructive" : ""
              } ${className}`}
              {...props}
            />

            {/* Error */}
            {error && (
              <p className="text-red-500 text-xs mt-1">{error?.message}</p>
            )}
          </>
        )}
      />
    </div>
  );
}
